import * as React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { AMBER } from "../../../Global/colors";
import { FA_BOTTOM_NAV_HEIGHT } from "../designTokens";

// Inline SVGs matching NeuraDesigns/field-admin-app/sites.html's <nav class="bottom-nav">
// exactly, rather than the closest MUI icon substitute.
const ICON_PROPS = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

function HomeIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M3 12l9-9 9 9M5 10v10h14V10" /></svg>;
}
function HSIcon(props) {
  return <svg {...ICON_PROPS} {...props}><rect x="5" y="2" width="14" height="20" rx="2" /><path d="m9 12 2 2 4-4" /></svg>;
}
function StockIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M4 7h16v13H4z" /><path d="M4 7l8-4 8 4" /></svg>;
}
function SitesIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>;
}
function MoreIcon(props) {
  return <svg {...ICON_PROPS} {...props}><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" /></svg>;
}

const TABS = [
  { label: "Home", path: "/field-admin/", Icon: HomeIcon },
  { label: "H&S", path: "/field-admin/hs/", Icon: HSIcon },
  { label: "Stock", path: "/field-admin/stock/", Icon: StockIcon },
  { label: "Sites", path: "/field-admin/sites/", Icon: SitesIcon },
  { label: "More", path: "/field-admin/more/", Icon: MoreIcon },
];

export default function FieldAdminBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    // Full-bleed bar with the tabs held to the same 860px column the page content uses.
    // The design caps the whole bar at 860px, but that's a mockup artefact — its
    // .bottom-nav sits inside a .phone-wrap the design itself labels a "Tablet frame",
    // with a border/radius/shadow bezel the nav's cap and corner radii align to. There's
    // no bezel in a real browser, so capping the bar left it as an island with bare page
    // either side on anything wider than 860px.
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(13,17,23,0.92)",
        backdropFilter: "blur(12px)",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        // Explicit so FA_BOTTOM_NAV_HEIGHT is the source of truth, not a measurement:
        // the H&S step footer sits directly on top of this and offsets by exactly it.
        height: FA_BOTTOM_NAV_HEIGHT,
        boxSizing: "border-box",
        pt: "10px",
        pb: "14px",
        zIndex: 80,
      }}
    >
      <Box
        sx={{
          maxWidth: "860px",
          mx: "auto",
          px: { xs: "16px", sm: "32px" },
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
        }}
      >
        {TABS.map(({ label, path, Icon }) => {
          // "/field-admin/" (Home) is a path-prefix of every other tab, so it needs an
          // exact match; every other tab should also stay active on its own sub-routes.
          const active = path === "/field-admin/" ? location.pathname === path : location.pathname.startsWith(path);
          return (
            <Box
              key={path}
              onClick={() => navigate(path)}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
                color: active ? AMBER : "rgba(255,255,255,0.45)",
              }}
            >
              <Icon width={22} height={22} />
              <Typography sx={{ fontSize: "0.72rem", fontWeight: 500 }}>{label}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
